import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';

const SalesTerms = () => {
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h1
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              textAlign: 'center',
              width: '66%',
              float:'none',
              margin: '5% auto',
              paddingTop: '5%',
              color: 'rgb(49, 103, 151)',
            }}
          >
            GENERAL TERMS & CONDITIONS OF SALE FOR PRODUCT & SERVICES <br />
          </h1>
          <p>
    The conditions set forth herein shall apply to all transactions for the
    supply of products and/or services entered into, or to be entered into,
    between Go Waterfall Digital (Pty) Ltd, Registration Number: 2016/216116/07
    hereinafter referred to as “the Company”, and the purchaser being any legal
    person, firm, partnership, close corporation or company, hereinafter
    referred to as “the Buyer”. “Item(s)” means any products and/or services
    offered by the Company on its platform. By placing an order on the Company
    for any Item you agree to be bound by these terms, which establishes a
    contractual relationship between you and the Company. If you do not agree
    to these Terms, you may not place an order on the Company for any Item.
    These Terms expressly supersede prior agreements or arrangements with you.
</p>
<p>
    1. ORDERS
</p>
<p>
    Any order placed by the Buyer on the Company, and accepted by the Company,
    may not be cancelled, in whole, or in part, or varied in any manner
    whatsoever, unless confirmed in writing by the Company.
</p>
<p>
    2. PRICING, PRODUCT &amp; SERVICES SPECIFICATIONS AND ERRORS
</p>
<p>
    2.1. Quoted prices are net and exclusive of VAT, unless otherwise stated.
</p>
<p>
    2.2. The Company will not be required to execute an order or compensate a
    Buyer for any loss if the Company made an error when presenting the item or
    service, formulating its characteristics or stating its price, and i) it
    should have been clear to the Buyer that such involved a printing error; or
    ii) if the Buyer should not, under the circumstances, have reasonably
    relied on the Company delivering the particular item or service, with
    stated characteristics, at that price.
</p>
<p>
    3. PAYMENT
</p>
<p>
    3.1. Payment shall be:
</p>
<p>
    3.1.1. in South African Rand;
</p>
<p>
    3.1.2. in full, without deduction or set-off;
</p>
<p>
    3.1.3. accepted via debit card, credit card (Visa or Mastercard) and direct
    transfer (EFT). Online credit card and debit card transactions will be
    facilitated through the PayGate payment platform. PayGate maintains Payment
    Card Industry (PCI) compliance and as such PayGate is responsible for
    securely storing, processing and transmitting card data to the PCI
    compliance standard. By placing an order on the Company, you agree that the
    terms and security policy found on PayGate’s website (www.paygate.co.za),
    as amended from time to time, will apply.
</p>
<p>
    3.2. The Company takes all reasonable steps to scrutinise all transactions
    to prevent attempted fraud and a transaction may be refused if the Company
    is not satisfied with its legitimacy.
</p>
<p>
    4. SERVICES
</p>
<p>
    The services constitute a technology platform that enables users of the
    Company’s mobile application or website to access the services or products
    supplied by independent third-party providers of such services and
    products, under agreement with the Company (“Third-Party Providers”).
</p>
<p>
    5. THIRD-PARTY PROVIDERS
</p>
<p>
    Items may be made available or accessed in connection with third-party
    services and content (including advertising) that the Company does not
    control. You acknowledge that different terms of use and privacy policies
    may apply to your use of such third-party services and content. The Company
    does not endorse such third-party services and content and in no event
    shall the Company be responsible or liable for any products or services of
    such Third-Party Providers.
</p>
<p>
    6. DELIVERY OF ITEMS
</p>
<p>
    6.1. All prices of the products posted on the website are exclusive of
    delivery costs. Delivery costs, where applicable, will be stated separately
    when settling the order and may vary for each order.
</p>
<p>
    6.2. The Company endeavours to supply items ordered, provided that the
    Company has such items in stock, to the delivery address within 5 days of
    the order confirmation and the required receipt of payment.
</p>
<p>
    6.3. Any time or date specified for delivery by the Company or the Buyer,
    in respect of any sale, shall be approximation and guide only. Time shall
    not be of the essence and the delivery periods are of an indicative nature
    only. Failure to receive the order on or before the anticipated delivery
    date or time will not constitute a breach of the terms and conditions of
    the order.
</p>
<p>
    6.4. The Company endeavours to effect delivery on any date specified by it
    or agreed upon by it but does not give any warranties of whatsoever nature
    or kind and it shall not be held responsible for any damages of whatsoever
    nature, or loss of profit, or any consequential or indirect damages which
    the Buyer may suffer as a result of such later delivery.
</p>
<p>
    6.5. The risk in and to the products purchased shall pass to the Buyer upon
    delivery. Such delivery will be deemed to have been affected upon tender of
    the products for acceptance by the Buyer, or the Buyer’s agent, during
    business hours, at the Buyers place of business or such other place
    nominated by the Buyer, or the Company’s place of business, if the Buyer
    elects to collect the products.
</p>
<p>
    6.6. No carrier, as agent of the Company, shall be obliged to enter the
    premises of the Buyer to enable offloading of products. However, if the
    delivery vehicle enters the Buyer’s premises, it shall be deemed to do so
    at the Buyer’s specific instance and request, and in that event the Company
    and/or its agent carrier shall accept no liability for damage or loss
    occasioned to the Buyer or any third-party, arising in any way from such
    entry and exit from the Buyer’s premises, or from the offloading, or from
    any negligent act or omission of the Company or its agent carrier during
    the course of entering, exiting or offloading. Further, the Buyer hereby
    indemnifies and holds the Company harmless against liability for any such
    damage or loss.
</p>
<p>
    7. RETURNS / REFUNDS POLICY
</p>
<p>
    7.1. The Company shall return products or refund Buyers in accordance with
    Sections 55 and 56 of the Consumer Protection Act 68 of 2008 and its
    Returns/Refunds Policy set out below.
</p>
<p>
    7.2. Products may not be returned unless the incorrect product has been
    supplied or the product is damaged or faulty upon delivery. In such an
    instance the Company will exchange the product on condition that: i) the
    product is returned in its original condition - including packaging,
    documentation, warranty cards, manuals and accessories; and ii) the Buyer
    returns the product within seven days of receipt and confirms same by
    sending a written notice to support@gowaterfall.co.za (within
    abovementioned seven day period); iii) All returns must be shipped freight
    (and insurance) prepaid. The onus is on the Buyer to ensure that the
    products returned are received by Company within 10 days of written notice.
</p>
<p>
    7.3. On receipt and acceptance of returned product Company will make all
    reasonable effort to exchange said product, but if replacement is not
    possible, Company will refund the purchase price, including delivery costs.
    Such amount will be refunded within 30 days of cancellation, beginning on
    the day written notice was given.
</p>
<p>
    7.4. Should a product be damaged in any way or missing any parts or
    accessories at the time of delivery, please notify us within 3 days by
    logging a return with support@gowaterfall.co.za . Breakages not reported
    within 3 days will not be refunded.
</p>
<p>
    7.5. The faulty product will be collected from the Buyer at no charge. Once
    the Company has inspected the product and validated the return, the Company
    will repair/replace the product as quickly as possible (if such a repair is
    possible/if the Company has the same product in stock as a replacement). If
    the Company is unable to repair or replace the product, it will credit the
    Buyer’s account with the purchase price of the product (note: a cash refund
    may be requested in lieu of store credit if preferred).
</p>
<p>
    7.6. What constitutes a defect? Any material imperfection in the
    manufacture of a product or any characteristic of a product which makes the
    product less acceptable than one would reasonably be entitled to expect in
    the circumstances. The following will NOT be regarded as defects and will
    not entitle you to a return under this clause 7.6:
</p>
<p>
    7.6.1. faults resulting from normal wear and tear;
</p>
<p>
    7.6.2. damage arising from negligence, user abuse or incorrect usage of the
    product;
</p>
<p>
    7.6.3. damage arising from electrical surges or sea air corrosion;
</p>
<p>
    7.6.4. damage arising from a failure to adequately care for the product;
</p>
<p>
    7.6.5. damage arising from unauthorised alterations to the product;
</p>
<p>
    7.6.6. where the specifications of a product, although accurately described
    on the website and generally fit for its intended purpose, do not suit you;
    and
</p>
<p>
    7.6.7. in relation to unboxed packages, signs of handling and/or
    repackaging.
</p>
<p>
    8. RESERVATION OF OWNERSHIP AND APPROPRIATION OF PAYMENTS
</p>
<p>
    8.1. Notwithstanding anything hereinabove or elsewhere contained, ownership
    of the products shall remain vested in the Company, until the Buyer has
    made full payment of the purchase price. No latitude or extension of time
    given to the Buyer shall in any way vitiate or novate the Company’s rights
    hereunder. In the event of any default on the part of the Buyer, the
    Company shall, without prejudice to any other rights it may have, and
    without notice, be entitled, on demand, to obtain return of the products,
    in so far as payment for the products has not been made in full.
</p>
<p>
    8.2. The Company is not obliged to accept returned products where the Buyer
    has made an error in its order, and the Buyer remains fully liable for the
    full price of the products so ordered.
</p>
<p>
    6. LIMITATION OF COMPANY’S LIABILITY
</p>
<p>
    8.3. The Company does not give any warranty against defects, whether
    latent, patent or otherwise, in the Items supplied. The Company does not
    give any warranties or guarantees of any other nature or make any
    representations whatsoever in respect of the Items, or of its fitness for
    any particular purpose, whether or not that particular purpose is, or could
    be, deemed to be known to the Company. The Company shall be deemed to be
    unaware of the particular purpose for which any product is purchased.
</p>
<p>
    8.4. The Company shall not be liable under any circumstances whatsoever,
    for any loss of profit or other special damages, arising from: i) its
    failure to meet its obligations under this agreement; and/or ii) any
    negligent act or omission.
</p>
<p>
    8.5. The onus shall be on the Buyer to satisfy itself that the Items
    supplied are fit for the purpose for which the Items are to be used. There
    is no obligation on the Company to guarantee the Item suitability.
</p>
<p>
    8.6. No agreement, warranty, condition, representation, promise, statement
    or undertaking, whether made before after a sale, shall be binding on the
    Company unless contained herein or confirmed by the Company in writing.
</p>
<p>
    9. PERSONAL DATA
</p>
<p>
    9.1. The Company shall take all reasonable steps to protect the personal
    information of Buyers. For the purpose of this clause, "personal
    information" shall be defined as detailed in the Promotion of Access to
    Information Act 2 of 2000.
</p>
<p>
    9.2. The Company will store the data provided by Buyers in a data file.
    Such data will be used to execute buyers' orders and will be kept for as
    long as is necessary to handle any complaints about the execution of an
    order. No data will be passed on to third parties if such should jeopardise
    the Buyer's privacy.
</p>
<p>
    10. GENERAL
</p>
<p>
    10.1. No variation, amendment or alteration of these Conditions of Sale
    shall be of any force or effect unless reduced to writing and signed by
    duly authorised representatives of the Company and the Buyer.
</p>
<p>
    10.2. The Buyer agrees that a signature of one of its employees, or any
    person purporting to represent the Buyer at the delivery address supplied
    by the Buyer, on a delivery note or waybill of the Company, or its carrier
    agent, will be proof of delivery of the products.
</p>
<p>
    10.3. The Company may, at its sole discretion, change these Terms and
    Conditions or any part thereof at any time without notice.
</p>
<p>
    11. WARRANTY PERIOD
</p>
<p>
    11.1. Third-Party Providers warrant that the products sold by the Company
    will be free from defects in materials or workmanship, under normal use and
    service, for the appropriate warranty period. The length and extent of the
    warranty period will depend on the period given by the Third-Party
    Providers and will be communicated to the Buyer for each order.
</p>
<p>
    11.2. The Company, or Third-Party Providers, the shall not be liable under
    this warranty for any products that the Buyer alleges are defective, where:
    i) those products have been repaired or altered by some any person other
    than the Company’s designated personnel or authorised representative,
    unless such repair or alteration was effected pursuant to prior written
    approval of the Company; or ii) where the Buyer fails
</p>
<p>
    to notify the Company of any alleged defect within the period of the
    warranty; or iii) where the products have been altered or damaged in any
    way which the Company reasonably believes to materially affect the
    performance and reliability of the products, or where the products have
    been subjected to misuse, neglect or accident.
</p>
<p>
    12. FORCE MAJEURE
</p>
<p>
    If performance in terms of this agreement becomes wholly or partially
    impossible due to causes beyond the control of the Company, such causes
    include, but are not be limited to: war, civil insurrection, natural
    disaster, vis maior, Government action and industrial disputes, then the
    Company shall be permitted to terminate the agreement at its discretion. If
    deliveries of Items will be delayed as a result of such causes, the Company
    will not be considered as being in breach of the agreement.
</p>
<p>
    13. BREACH
</p>
<p>
    13.1. Where the Buyer, in any way, breaches the terms of the agreement, and
    does not remedy its breach within 24 hours of verbal or written notice
    calling upon it to do so, then the Company, in its discretion may terminate
    this agreement and claim: i) return of the products; ii) payment equal to
    the current market value of the Items; iii) any damages it may have
    sustained as a result of the Buyers breach of the agreement. The Company
    may, in addition to the above, elect to retain any monies already received
    from the Buyer, to settle any damages which it may have sustained as a
    result of the Buyer’s breach of the agreement.
</p>
<p>
    13.2. The Company and the Buyer agree that all disputes will be adjudicated
    in the Magistrate’s Court in accordance with the Laws of the Republic of
    South Africa.
</p>
<p>
    14. COSTS
</p>
<p>
    If the Buyer is in anyway in breach of the agreement and the Company
    engages the services of an attorney to collect the whole or portion of the
    amount owing to it by the Buyer, or to sue for any other damages as a
    result of breach by the Buyer, the Buyer shall be liable to pay all costs
    occasioned as a result thereof, including collection charges and costs on
    an attorney and own client scale.
</p>
<p>
    15. DOMICILIUM CITANDI ET EXECUTANDI
</p>
<p>
    The Company chooses as its domicilium citandi et executandi for all
    purposes under this agreement, whether in respect of court process, notice,
    or other documents or communication of whatsoever nature at: Go Waterfall,
    Mac Mac Building, Maxwell Office Park, Magwa Crescent West, Waterfall City,
    Jukskei View, South Africa, 2090.
</p>
        </Col>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  width: 95% !important;
  height: 100%;
  position: relative;
  float: none;
  margin: 0 auto;
  background: #fff;
  padding: 2%;
`;

export default SalesTerms;
